import AuthLayout from "../../components/AuthLayout"
import Input from "../../core-ui/Input"
import { Link, useNavigate } from "react-router-dom"
import { useForm } from "react-hook-form"
import API from "../../utils/apiClient"
import { useToast } from "../../utils/ToastProvider"

const OtpVerify = () => {
  const navigate = useNavigate()
  const { addToast } = useToast()
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    watch,
  } = useForm({
    defaultValues: {
      email: "",
      otp: "",
    }
  })

  const handleSendOtp = async () => {
    const email = watch("email")
    if (!email) {
      addToast({
        title: "Email required!",
        description: "Youe Email is required to send OTP.",
        type: "error",
      })
      return
    }
    try {
      const res = await API.post(`/user/send-otp/${email}?purpose=signup`)
      if (res.data.status === "success") {
        addToast({
          title: "Success!",
          description: "OTP send successfully!"
        })
      }
    } catch (otpError) {
      addToast({
        title: "Error!",
        description: "Unexpected error occured. Try Again.",
        type: "error"
      })
    }
  }

  const onSubmitHandler = async (data) => {
    try {
      const res = await API.post("/user/verify-otp", {
        email: data.email,
        otp: data.otp
      })
      if (res.data.status === "success") {
        addToast({
          title: "Success!",
          description: "OTP verified successfully!"
        })
        navigate(`/complete-signup?email=${data.email}&ref=${res.data.data.verification_reference}`)
      }
    } catch (verifyOTPError) {
      addToast({
        title: "Error!",
        description: "Unexpected error occured. Try Again.",
        type: "error"
      })
    }
  }

  return (
    <AuthLayout>
      {/* Heading */}
      <h1 className="text-2xl font-semibold text-center text-gray-800 mb-2">
        Welcome to ZeroEqualOne !
      </h1>
      <p className="text-center text-gray-500 mb-8">
        Enter your email and password to login
      </p>

      {/* Form */}
      <form onSubmit={handleSubmit(onSubmitHandler)} className="space-y-6">
        {/* Email Input */}
        <div className="relative">
          <Input
            type="email"
            name="email"
            placeholder="Email"
            required={true}
            register={register}
          />
          <button
            type="submit"
            onClick={handleSendOtp}
            className="absolute right-2 px-3 my-2 py-1 bg-blue-500 text-white rounded-md text-sm hover:bg-blue-600 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Send OTP
          </button>
          {errors.email && <p className="mt-2 text-secondary">Email is required</p>}
        </div>

        {/* Password Input */}
        <div className="relative">
          <Input
            type="text"
            name="otp"
            placeholder="Enter OTP"
            required={true}
            register={register}
          />
          {errors.otp && <p className="mt-2 text-secondary">OTP is required</p>}
        </div>
        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full bg-primary text-white py-3 rounded-lg hover:bg-primaryDark transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 font-medium"
        >
          Verify OTP
        </button>
      </form>

      {/* Sign Up Link */}
      <p className="mt-8 text-center text-gray-500 text-sm">
        Already have an Account ? {" "}
        <Link to="/login" className="text-primary hover:text-primaryDark font-medium">
          Login
        </Link>
      </p>
    </AuthLayout>
  )
}

export default OtpVerify
